module.exports = {"공모전 참여":"Join the Contest","공모전 작품의 태그는 9개까지 이용 가능합니다.":"You can select up to 9 tags for contest story.","공모전 태그는 삭제하실 수 없습니다.":"You can not delete '#2022ChatieWritingContest' tag.","공모전 참여 여부는 수정이 불가능합니다.":"You can not un-join after joining the contest.","팬픽 작품은 공모전에 참여할 수 없습니다.":"Fan fiction stories can not participate in the contest"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en/event.json
// module id = 1759
// module chunks = 55